import { toast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';
import { Star } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';

const TradeInAppraisalFavoriteUnfavorite = () => {
  const favorited = false;

  return (
    <div
      onClick={() => {
        toast({
          title: 'Trade In Appraisal Favorite Unfavorite Not Implemented',
          description: 'Request for this feature over slack.',
        });
      }}
    >
      <Tooltip>
        <TooltipTrigger>
          <Star
            className={cn('h-3.5 w-3.5 cursor-pointer', {
              'fill-yellow-500': favorited,
            })}
          />
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          align="center"
          className="flex flex-row gap-1 items-center"
        >
          {favorited ? (
            <div>Unfavorite trade in appraisal</div>
          ) : (
            <div>Favorite trade in appraisal</div>
          )}
          {/* <KeyboardKeyIcon>{HOTKEYS.TRADE_IN_APPRAISAL_FAVORITE_UNFAVORITE}</KeyboardKeyIcon> */}
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export default TradeInAppraisalFavoriteUnfavorite;
